import React, { useEffect } from 'react';
import './UnderConstruction.css';

const bgImage = `${process.env.PUBLIC_URL}/under-construction.jpg`;

const UnderConstruction = () => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = bgImage;
    link.setAttribute('fetchpriority', 'high');
    document.head.appendChild(link);
    return () => {
      if (link.parentNode) link.parentNode.removeChild(link);
    };
  }, []);

  return (
    <div className="uc-root">
      <img
        src={bgImage}
        alt=""
        className="uc-bg"
        fetchpriority="high"
        loading="eager"
        decoding="async"
        aria-hidden="true"
      />
      <div className="uc-overlay" aria-hidden="true" />

      <main className="uc-content" role="main">
        <h1 className="uc-headline">
          We'll be here soon
          <span className="uc-dots" aria-hidden="true" />
        </h1>
        <p className="uc-subtext">
          We&rsquo;re currently under construction to bring you the best of
          the Tri-Cities. Check back soon.
        </p>
      </main>
    </div>
  );
};

export default UnderConstruction;
